/**
*
* usePendingForm
*
*/

import { SCHEDULE_DELETE, SCHEDULE_DRAFT, SCHEDULE_RELEASED, SCHEDULE_SCHEDULED, SCHEDULE_UNDEFINED } from 'components/Post/constants.js';
import { pick } from 'lodash-es';
import useSafeState from 'utils/useSafeState.js';
import { addBreadcrumb } from 'utils/sentry.js';
import getSuccessMessage from './getSuccessMessage.js';

const pickFields = ['id', 'title', 'body', 'status', 'scheduled'];

function usePendingForm(onSubmit, onDelete, defaultValues, noDirectSend) {
  const [show, setShow] = useSafeState(false);
  const [working, setWorking] = useSafeState(false);

  const submitButton = { status: SCHEDULE_UNDEFINED };

  function handleWorkingSubmit(data) {
    const result = onSubmit(data);
    if (result instanceof Promise) {
      setWorking(true);
      result.finally(() => setWorking(false));
    }
    return result;
  }

  function handleSubmit(data) {
    let { status } = submitButton;
    const defaultStatus = noDirectSend ? SCHEDULE_DRAFT : SCHEDULE_RELEASED;
    const dataStatus = data.status ?? defaultValues.status;
    const dataScheduled = data.scheduled ?? defaultValues.scheduled;
    if (status === SCHEDULE_UNDEFINED) {
      status = dataStatus === SCHEDULE_SCHEDULED ? SCHEDULE_SCHEDULED : defaultStatus;
    }
    if (submitButton.status === SCHEDULE_SCHEDULED || (status === SCHEDULE_SCHEDULED && !dataScheduled)) {
      setShow(true);
      return;
    }
    const newData = { ...defaultValues, ...data, status, success: getSuccessMessage(status) };
    addBreadcrumb({
      category: 'conversations',
      level: 'debug',
      message: 'PendingForm',
      data: {
        newData: pick(newData, pickFields),
        data: pick(data, pickFields),
        dataStatus,
        dataScheduled,
      },
    });
    handleWorkingSubmit(newData);
  }

  function handleDate(data, scheduled) {
    const status = scheduled ? SCHEDULE_SCHEDULED : SCHEDULE_DRAFT;
    handleWorkingSubmit({ ...data, status, scheduled, success: getSuccessMessage(status) });
  }

  function handleClick(data, status) {
    submitButton.status = status;
    switch (status) {
      case SCHEDULE_DRAFT:
        handleSubmit(data);
        break;
      case SCHEDULE_DELETE:
        onDelete();
        break;
      default:
      // submitted already, no further action
    }
  }

  return { show, setShow, working, handleSubmit, handleDate, handleClick };
}

export default usePendingForm;
